module.exports = __webpack_public_path__ + "img/sea-4.8f9d942b.jpg";